import { message, Tooltip } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { getPermissions } from '../../../actions/userSlice';
import { setCurrentQuery } from '../../../containers/CohortBuilder/cohortBuilderSlice';
import { canEditQuery, isCohortExportable } from '../../../containers/CohortBuilder/PermissionsUtil';
import { Query } from '../../../containers/HealthcareUsageReport/types/CohortQuery';
import { generatePathway, setCurrentPathwayAndRefresh } from '../../../containers/PathwayViewer/actions';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { Routes } from '../../../pages/routes';
import styles from "./ExportButton.module.scss";
import {PathwayViewer} from "../../cohort-navigation/icons/PathwayViewer";
import classNames from "classnames";

const ExportPWVButton = ({ query }: { query: Query }) => {
    const history = useHistory()
    const dispatch = useAppDispatch()
    const permissions = useAppSelector(getPermissions)

    const pathwayToolTip = (query: Query) => {
        switch (query.pathwayStatus) {
            case 'NONE':
                return {
                    colour: '#0000000',
                    label: 'generate cohort pathways',
                    action: () => { dispatch(generatePathway(query)) }
                }
            case 'WAITING':
                return {
                    className: styles['waiting'],
                    label: 'waiting for generation of cohort pathways'
                }
            case 'RUNNING':
                return {
                    className: styles['running'],
                    label: 'generating cohort pathways'
                }
            case 'COMPLETE':
                return {
                    className: styles['complete'],
                    label: 'view cohort pathways',
                    action: () => {
                        dispatch(setCurrentQuery(query.id))
                        dispatch(setCurrentPathwayAndRefresh())
                        history.push(Routes.MyPWV)
                    }
                }
            case 'FAILED':
                return {
                    className: styles['failed'],
                    label: 'failed to generate cohort pathways'
                }
            default:
                return {
                    colour: '#0000000',
                    label: 'unknown status'
                }
        }
    }

    if (isCohortExportable(query)) {
        const config = pathwayToolTip(query)
        return (
            <Tooltip title={`${config.label}`} >
                <span
                    className={classNames(styles['export-icon'], config.className)}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (permissions.pwv && canEditQuery(permissions)) {
                            if (config.action) {
                                config.action()
                            }
                        } else {
                            message.warn('You do not have access to the PWV.');
                        }
                    }} 
                    data-testid={`query-list-pwv-status-${query.id}-${query.pathwayStatus}`}>
                    <PathwayViewer/>
                </span>
            </Tooltip>
        )
    }
    return null
}
export default ExportPWVButton